var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%", padding: "40px" } }, [
    _vm.isLoading
      ? _c("div", { staticClass: "loading-overlay" }, [
          _c("div", { staticClass: "loading-spinner" }),
          _vm._v(" "),
          _c("div", { staticClass: "loading-text" }, [_vm._v("Carregando...")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "header",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isDashboardMode,
            expression: "!isDashboardMode"
          }
        ],
        attrs: { id: "wrapper-header", role: "main" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "padding-left": "15px",
              "padding-right": "15px",
              "padding-bottom": "5px"
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "wrapper-header-block col-12" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showGrid,
                        expression: "showGrid"
                      }
                    ],
                    attrs: { id: "pnlGrid_ren" }
                  },
                  [
                    _c(
                      "b-collapse",
                      {
                        staticStyle: { display: "block!important" },
                        attrs: { id: "collapse1" }
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "mb-1 block-resumo",
                                    attrs: { "no-body": "", id: "resumo" }
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "p-2",
                                        attrs: {
                                          "header-tag": "header",
                                          role: "tab"
                                        }
                                      },
                                      [_vm._v("Resumo")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-card-body",
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [_vm._v("Conta")]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "light",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.leadAccount)
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Empresa")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "light",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.leadClient)
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    "Consumido pela Empresa"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "info",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          (_vm.saldoTotal -
                                                            _vm.leadMyAccumulated <
                                                          0
                                                            ? 0
                                                            : _vm.saldoTotal -
                                                              _vm.leadMyAccumulated
                                                          ).toLocaleString(
                                                            "PT-br"
                                                          )
                                                        ) +
                                                        "\n                              "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Consumido por mim")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "info",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.leadMyAccumulated.toLocaleString(
                                                          "PT-br"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "mb-1 block-resumo",
                                    attrs: { "no-body": "", id: "ciclo" }
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "p-1",
                                        attrs: {
                                          "header-tag": "header",
                                          role: "tab"
                                        }
                                      },
                                      [_vm._v("Período")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-card-body",
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Início")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "light",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.periodoInicio.toLocaleDateString(
                                                          "pt-BR",
                                                          _vm.options
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Término")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "light",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.periodoFim.toLocaleDateString(
                                                          "pt-BR",
                                                          _vm.options
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [_vm._v("Ciclo")]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "light",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.leadCycleType)
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "mb-1 block-resumo",
                                    attrs: { "no-body": "", id: "indicators" }
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "p-1",
                                        attrs: {
                                          "header-tag": "header",
                                          role: "tab"
                                        }
                                      },
                                      [_vm._v("Indicadores")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-card-body",
                                      [
                                        _c(
                                          "b-list-group",
                                          [
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Total da Cota")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "info",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.TotalCota.toLocaleString(
                                                          "PT-br"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Total Consumido:")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "info",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.saldoTotal.toLocaleString(
                                                          "PT-br"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Saldo Disponível:")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "info",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (_vm.TotalCota -
                                                          _vm.saldoTotal <
                                                        0
                                                          ? 0
                                                          : _vm.TotalCota -
                                                            _vm.saldoTotal
                                                        ).toLocaleString(
                                                          "PT-br"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("hr", {
                                              staticStyle: {
                                                "border-color":
                                                  "rgba(114, 108, 108, 0.3)",
                                                "background-color":
                                                  "rgba(0, 0, 0, 0) !important",
                                                padding:
                                                  "0px 0px 0px 0px !important",
                                                margin:
                                                  "10px 0px 0px 0px !important",
                                                height: "10px"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-list-group-item",
                                              {
                                                staticClass:
                                                  "item-group-nav d-flex justify-content-between align-items-center"
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Consumo Gratuito:")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "info",
                                                      pill: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.leadFree.toLocaleString(
                                                          "PT-br"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: " app-container", staticStyle: { "padding-top": "50px" } },
      [
        _vm.leadMyAccumulated === 0
          ? _c(
              "div",
              { staticClass: "text-lg-center", attrs: { id: "divNoPurchase" } },
              [
                _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                  _c("h5", { staticClass: "alert-heading" }, [
                    _vm._v("Você não realizou nenhuma compra")
                  ])
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.leadMyAccumulated > 0
          ? _c(
              "div",
              { staticClass: "table-consumo" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "ejs-grid",
                          {
                            ref: "grid",
                            attrs: {
                              allowFiltering: true,
                              allowGrouping: false,
                              filterSettings: _vm.filterOptions,
                              allowPaging: true,
                              pageSettings: _vm.pageSettings,
                              dataSource: _vm.data,
                              showColumnChooser: true,
                              allowResizing: true,
                              allowSorting: true
                            }
                          },
                          [
                            _c(
                              "e-columns",
                              [
                                _c("e-column", {
                                  attrs: {
                                    field: "cStatusDesc",
                                    headerText: "",
                                    width: "90",
                                    textAlign: "Center",
                                    template: _vm.statusTemplate
                                  }
                                }),
                                _vm._v(" "),
                                _c("e-column", {
                                  attrs: {
                                    field: "dtAddInFrmt",
                                    headerText: "Solicitado em",
                                    width: "140"
                                  }
                                }),
                                _vm._v(" "),
                                _c("e-column", {
                                  attrs: {
                                    field: "cAlias",
                                    headerText: "Nome",
                                    textAlign: "Left",
                                    width: "250",
                                    allowResizing: "true",
                                    allowTextWrap: "true"
                                  }
                                }),
                                _vm._v(" "),
                                !_vm.isDashboardMode
                                  ? _c("e-column", {
                                      attrs: {
                                        field: "cTick",
                                        headerText: "Chave",
                                        width: "100",
                                        allowResizing: "true",
                                        textAlign: "Left",
                                        visible: true
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isDashboardMode
                                  ? _c("e-column", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.isDashboardMode,
                                          expression: "!isDashboardMode"
                                        }
                                      ],
                                      attrs: {
                                        field: "nCountChunk",
                                        headerText: "Total de Registros",
                                        width: "180",
                                        allowResizing: "true",
                                        visible: true
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isDashboardMode
                                  ? _c("e-column", {
                                      attrs: {
                                        field: "nNewOnes",
                                        headerText: "Contabilizados",
                                        width: "170",
                                        allowResizing: "true",
                                        visible: true
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "11" } },
                      [
                        _c(
                          "b-row",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.configFile,
                                expression: "configFile"
                              }
                            ],
                            staticStyle: { "padding-top": "10px" }
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticStyle: { "padding-top": "5px" },
                                attrs: { cols: "3" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#6c757d"
                                    }
                                  },
                                  [_vm._v("Delimitador de campos:")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.columnDelimiters,
                                    "text-field": "text",
                                    "value-field": "value",
                                    size: "sm"
                                  },
                                  model: {
                                    value: _vm.columnDelimiter,
                                    callback: function($$v) {
                                      _vm.columnDelimiter = $$v
                                    },
                                    expression: "columnDelimiter"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticStyle: { "padding-top": "5px" },
                                attrs: { cols: "2" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#6c757d"
                                    }
                                  },
                                  [_vm._v("Delimitador de texto:")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "3" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.textDelimiters,
                                    "text-field": "text",
                                    "value-field": "value",
                                    size: "sm"
                                  },
                                  model: {
                                    value: _vm.textDelimiter,
                                    callback: function($$v) {
                                      _vm.textDelimiter = $$v
                                    },
                                    expression: "textDelimiter"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticStyle: { margin: "10px" },
                            attrs: { title: "Configurar", variant: "link" },
                            on: { click: _vm.showConfigFile }
                          },
                          [_c("i", { staticClass: "fas fa-cog" })]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }